import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        this.$video = this.$('video')[0]

        this.events = {
            mouseenter: {
                "video": "play"
            },
            mouseleave: {
                "video": "pause"
            },
        }
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.moduleID = this.el.dataset.moduleVideoInview
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Callbacks
    ///////////////
    onInview(args) {
        let $target

        if (args.target) {
            $target = args.target
        } else if (args.targetEl) {
            $target = args.targetEl
        } else {
            return
        }

        const moduleID = $target.dataset.moduleVideoInview

        if (moduleID !== this.moduleID) return

        if (args.way === 'enter') {
            this.play()
        } else if (args.way === 'leave') {
            this.pause()
        }
    }

    ///////////////
    // Methods
    ///////////////
    play() {
        this.$video.play()
    }

    pause() {
        this.$video.pause()
    }
}